import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import 'normalize.css'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-default/index.css'
import 'element-ui/lib/theme-chalk/index.css'
//import './assets/theme/theme-green/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import routes from './routes'
import Mock from './mock'
// Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'
import './assets/scss/main.scss';
import {setThat} from './api/apiConfig'

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)

NProgress.configure({ showSpinner: false });

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.path == '/login') {
      sessionStorage.removeItem('user');
  }
  let user = JSON.parse(sessionStorage.getItem('user'));
  if (!user && to.path != '/login') {
    next({ path: '/login' })
  } else if (to.path == '/' 
    || to.path == ''
    || to.path == '/#'
    || to.path == '/#/'
    ) {
    next({ path: '/desktop' })
  } else {
    next()
  }
})

router.afterEach(transition => {
NProgress.done();
});

let that = new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount('#app')

// 初始化apiConfig中的that，使其能访问当前vue对象
setThat(that);



// WEBPACK FOOTER //
// ./src/main.js